import React from 'react';
import { usePopUp } from '../../queries/popup';

export const PopUpPage = () => {
  const { popUp } = usePopUp();

  return (
    <div className="w-screen overflow-hidden px-6 md:mx-auto md:mt-16 md:max-w-screen-xl">
      <div className="flex items-center justify-between">
        <p className="hidden text-36 text-[#221F20] md:block">
          팝업스토어 문의하기
        </p>
      </div>
      <div className="mt-10 h-full w-full md:mt-20">
        {/* <p
          className="hidden md:flex md:flex-col"
          dangerouslySetInnerHTML={{ __html: popUp.pcContents }}
        /> */}
        <p
          className=""
          dangerouslySetInnerHTML={{ __html: popUp.mobileContents }}
        />
      </div>
    </div>
  );
};
